// src/modules/competitions/components/ImageComparator.tsx

import React from 'react';
import ReactCompareImage from 'react-compare-image';
import '../styles/imageComparator.css';

interface Props {
    exampleImage: string;
    participantImage: string;
    exampleLabel?: string;
    participantLabel?: string;
}

const ImageComparator: React.FC<Props> = ({
    exampleImage,
    participantImage,
    exampleLabel = 'EJEMPLO',
    participantLabel = 'TU IMAGEN'
}) => {
    return (
        <div className="image-comparator-wrapper">
            <div className="comparator-labels">
                <span className="label-left">{exampleLabel}</span>
                <span className="label-right">{participantLabel}</span>
            </div>
            <div className="comparator-container">
                <ReactCompareImage
                    leftImage={exampleImage}
                    rightImage={participantImage}
                    sliderLineWidth={3}
                    sliderLineColor="#3498db"
                    handleSize={40}
                    hover={true}
                />
            </div>
        </div>
    );
};

export default ImageComparator;